<template>
  <b-row class="pointer-true justify-content-start align-items-center">
    <div
      v-for="(color,index) in colors"
      :key="color.id"
      class="palette-cell rounded mr-1"
      :class="[{'selected-cell': currentColor == index},
      {'white-sell': index == 0}]"
      :style="{background: color}"
      @click.self="ChangeColor(index)"
    ></div>
    <vue-slider class="col mx-2 ml-sm-2 ml-md-2 ml-lg-2 slider" v-model="alfa" @change="ChangeAlfa" />
  </b-row>
</template>

<script>
import VueSlider from "vue-slider-component";
import "@/assets/css/vue-slider.css";
export default {
  components: {
    VueSlider
  },
  data() {
    return {
      colors: [
        "#ffffff",
        "#000000",
        "#ff3300",
        "#991f00",
        "#ff9933",
        "#994d00",
        "#ffff00",
        "#999900",
        "#33cc33",
        "#1f7a1f",
        "#3399ff",
        "#004d99",
        "#cc33ff",
        "#730099",
        "#ff3399",
        "#99004d"
      ],
      currentColor: 1,
      lastColor: 0,
      alfa: 100
    };
  },
  beforeMount() {
    document.addEventListener("keydown", this.KeyHandler);
  },
  beforeDestroy() {
    document.removeEventListener("keydown", this.KeyHandler);
  },
  methods: {
    KeyHandler(e) {
      let k = e.keyCode;
      // left arrow
      if (k == 37 || k == 65) this.PrevColor();
      // right arrow
      else if (k == 39 || k == 68) this.NextColor();
      // num 0 || Q
      else if (k == 96 || k == 81) this.LastColor();
    },
    ChangeAlfa() {
      this.$emit(
        "change_color",
        this.ConvertColor(this.colors[this.currentColor])
      );
    },
    ChangeColor(index) {
      this.lastColor = this.currentColor;
      this.currentColor = index;
      this.$emit("change_color", this.ConvertColor(this.colors[index]));
    },
    // ConvertColor(color) {
    //   var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(color);
    //   if (result) {
    //     let r = parseInt(result[1], 16);
    //     let g = parseInt(result[2], 16);
    //     let b = parseInt(result[3], 16);
    //     return `rgba(${r},${g},${b},${this.alfa / 100})`;
    //   }
    //   return null;
    // },
    ConvertColor(color) {
      var hex = Math.round((this.alfa / 100) * 255).toString(16);
      hex = hex.length == 1 ? "0" + hex : hex;
      return `${color}${hex}`;
    },
    PrevColor() {
      let i = this.currentColor > 0 ? this.currentColor : this.colors.length;
      this.ChangeColor(i - 1);
    },
    NextColor() {
      let i =
        this.currentColor < this.colors.length - 1 ? this.currentColor : -1;
      this.ChangeColor(i + 1);
    },
    LastColor() {
      this.ChangeColor(this.lastColor);
    }
  }
};
</script>

<style scoped>
.slider {
  min-width: 50px;
  min-height: 12px;
}
.white-sell {
  border: 1px solid #aaa;
}
.palette-cell {
  max-width: 22px;
  max-height: 22px;
  min-width: 10px;
  min-height: 10px;
  width: 18px;
  height: 18px;
  transition: box-shadow 0.3s;
}
.selected-cell {
  border: 2px solid #aaa;
  box-shadow: 0px 0px 3px 1px #00aeff;
  width: 22px;
  height: 22px;
}
</style>